import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  borderColor: themeStyle.varBackgroundAlt,
  backgroundColor: themeStyle.varBackgroundAlt,
  color: themeStyle.varInkMedium,
  darkColor: themeStyle.varInkMedium,
  fontWeight: themeStyle.fontSemiBold,
  fontSize: themeStyle.fontSize11,
};
